"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var fade_in_1 = require("../fade-in");
function TabPanel(props) {
    var tab = props.tab, children = props.children;
    return (react_1.default.createElement("div", { id: tab.panelId, role: "tabpanel", "aria-labelledby": tab.id, hidden: !tab.isActive },
        react_1.default.createElement(fade_in_1.FadeIn, { duration: "400ms" }, children)));
}
exports.TabPanel = TabPanel;
//# sourceMappingURL=tabpanel.js.map